import qs from 'query-string';
import { WidgetConfiguration } from 'types';
import { WidgetConfigProvider, URL_WIDGET_CONFIG_KEYS } from './types';

function isWidgetConfigKey(key: string): key is keyof WidgetConfiguration {
  return URL_WIDGET_CONFIG_KEYS.includes(key as keyof WidgetConfiguration);
}

function paramFormatter<K extends keyof WidgetConfiguration>(
  key: K,
  value: string | string[] | null,
): WidgetConfiguration[K] | string | undefined {
  if (Array.isArray(value)) {
    return undefined;
  }

  if (key === 'direction' && typeof value === 'string') {
    return value.toLowerCase();
  }

  return value === null ? undefined : value;
}

const urlConfigProvider: WidgetConfigProvider = () => {
  const queryParams = qs.parse(window.location.search);

  return Object.keys(queryParams).reduce((acc, paramKey) => {
    if (isWidgetConfigKey(paramKey)) {
      acc[paramKey] = paramFormatter(paramKey, queryParams[paramKey]);
    }
    return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any);
};

export default urlConfigProvider;
